import React, { useState } from "react";

const Counter = () => {
  const [count, setCount] = useState(0);

  return (
    <section>
      <p>{count}</p>
      <div>
        <button onClick={() => setCount((c) => c + 1)}>+</button>
        <button onClick={() => setCount((c) => c - 1)}>-</button>
        <button onClick={() => setCount(0)}>0</button>
      </div>
    </section>
  );
};

export default Counter;
